import EmptyListView from './EmptyListView';
import './EmptyList.css';

export default EmptyListView;
